import React, { memo, useCallback } from 'react';
import { PDFWidgetForm } from './PDFBlock';
import { FormInput, FormCheckbox } from '@core/components/form';
import Dropzone from 'react-dropzone';
import { UploadAPI } from '@business/api/upload';
import { tap } from 'rxjs/operators';
export interface PDFBlockSettingsProps {
  form: PDFWidgetForm;
}

export const PDFBlockSettings = memo((props: PDFBlockSettingsProps) => {
  const { form } = props;

  const onDrop = useCallback(
    (files: File[]) => {
      if (!files) return null;
      if (files.length == 0) return null;

      files.forEach(file => {
        UploadAPI.upload('proposals', file)
          .pipe(tap(res => form.patchValue({ file: res })))
          .subscribe();
      });
    },
    [form],
  );
  return (
    <div>
      <FormInput control={form.controls.height} type="number" />

      <div>
        <Dropzone onDrop={onDrop} maxFiles={1} accept="application/pdf">
          {({ getRootProps, getInputProps }) => (
            <div className="dropzone">
              <div className="dz-message needsclick" {...getRootProps()}>
                <input {...getInputProps()} />
                <div className="dz-message needsclick">
                  <div className="mb-3">
                    <i className="display-4 text-muted bx bxs-cloud-upload" />
                  </div>
                  <h4>Drop files here</h4>
                </div>
              </div>
            </div>
          )}
        </Dropzone>
      </div>
    </div>
  );
});
